import styled from 'styled-components';
import { CommonDetails } from '../common-styles.styles';

export const BreadCrumbs = styled(CommonDetails)`
  padding: 10px;
  /* margin: 20px 10px 10px 10px; */
  text-align: center;
  font-size: ${props => (props.isCityCountry ? '13px' : '16px')};
  span {
    color: #3872bd;
    font-weight: 600;
    cursor: pointer;
    font-size: ${props => (props.isCityCountry ? '12px' : '15px')};
    margin-top: 5px;
  }
  a {
    text-decoration: none;
  }
`;
